import axios from '../../../axiosConfig';

// Servicio centralizado para manejar novedades y eventos del flujo OnRoad
export class NovedadesService {
    static endpoint = '/enviarNovedades';

    // Obtiene la geolocalización actual del dispositivo
    static async obtenerGeolocalizacion() {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject(new Error('La geolocalización no es compatible con este navegador.'));
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve({
                        latitud: position.coords.latitude,
                        longitud: position.coords.longitude,
                        precision: position.coords.accuracy,
                        timestamp: new Date().toISOString()
                    });
                },
                () => {
                    reject(new Error('No se pudo obtener la geolocalización.'));
                },
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 60000
                }
            );
        });
    }

    // Prepara los datos base comunes para cualquier novedad o evento
    static prepararDatosBase(tipoEvento, observaciones = '', coords = null) {
        const conductor = localStorage.getItem('idConductor');
        const manifiesto = localStorage.getItem('manifiesto');
        const empresa = localStorage.getItem('empresa');
        const tokenConductor = localStorage.getItem('tokenOperacion');
        const tenantEmpresa = localStorage.getItem('tenantEmpresa');

        return {
            manifiesto,
            empresa,
            puestoControl: tipoEvento,
            observaciones: `[ON ROAD: ${conductor}] ${observaciones}`,
            latitud: coords?.latitud, 
            longitud: coords?.longitud,
            tokenConductor,
            tenantEmpresa
        };
    }

    // Envía una normalidad en ruta
    static async reportarNormalidad(observaciones = 'REPORTA NORMALIDAD EN RUTA') {
        try {
            const coords = await this.obtenerGeolocalizacion();
            const tipoEvento = `Normalidad en RUTA`;
            const datosBase = this.prepararDatosBase(tipoEvento, observaciones, coords);
            
            const formData = new FormData();
            
            Object.entries(datosBase).forEach(([key, value]) => {
                if (value !== null && value !== undefined) {
                    formData.append(key, value);
                }
            });

            const response = await axios.post(this.endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data?.success) {
                return {
                    success: true,
                    message: response.data.message || 'Normalidad reportada exitosamente',
                    data: response.data
                };
            } else {
                return {
                    success: false,
                    message: response.data?.message || 'Error al reportar normalidad',
                    errors: response.data?.errors || null
                };
            }

        } catch (error) {
            console.error('Error enviando normalidad:', error);
            const backendMessage = error.response?.data?.message;
            const backendErrors = error.response?.data?.errors;
            
            return {
                success: false,
                message: backendMessage || error.message || 'Error de conexión al reportar normalidad',
                errors: backendErrors || null,
                statusCode: error.response?.status
            };
        }
    }

    // Envía una o múltiples novedades
    static async reportarNovedades({ novedades, observaciones = '', evidencia = null }) {
        try {
            const coords = await this.obtenerGeolocalizacion();
            const tipoEvento = Array.isArray(novedades) ? 
                `${novedades.join(', ')}` : 
                `${novedades}`;
            const datosBase = this.prepararDatosBase(tipoEvento, observaciones, coords);
            
            const formData = new FormData();
            
            Object.entries(datosBase).forEach(([key, value]) => {
                if (value !== null && value !== undefined) {
                    formData.append(key, value);
                }
            });

            // Agregar evidencia si existe
            if (evidencia && evidencia instanceof File) {
                formData.append('novedadImagen', evidencia);
            }

            const response = await axios.post(this.endpoint, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data?.success) {
                return {
                    success: true,
                    message: response.data.message || 'Novedad(es) reportada(s) exitosamente',
                    data: response.data
                };
            } else {
                return {
                    success: false,
                    message: response.data?.message || 'Error al reportar novedad(es)',
                    errors: response.data?.errors || null
                };
            }

        } catch (error) {
            console.error('Error enviando novedad(es):', error);
            const backendMessage = error.response?.data?.message;
            const backendErrors = error.response?.data?.errors;
            
            return {
                success: false,
                message: backendMessage || error.message || 'Error de conexión al reportar novedad(es)',
                errors: backendErrors || null,
                statusCode: error.response?.status
            };
        }
    }
}